import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Flex,
  Heading,
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  VStack,
  Spinner,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Badge,
} from "@chakra-ui/react";

import {
  AddIcon,
  SearchIcon,
} from "@chakra-ui/icons";

import { useQuery } from "react-query";

import DocumentRequestCard from "./DocumentRequestCard";
import DocumentRequestDetailsModal from "./DocumentRequestDetailsModal";
import NewRequestModal from "./NewRequestModal";

import {
  getDocumentrequests,
  getDocumentrequestsByid,
  getDocRequestsService,
  
} from "../../services/tankstackApiRequest";

const RequestDrawer = ({ isOpen, onClose }) => {

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [category, setCategory] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");


  const [currentPage, setCurrentPage] = useState(1);

  const PAGE_LIMIT = 10;


  const [isNewRequestOpen, setIsNewRequestOpen] =
    useState(false);

  const [
    isServiceSelectionOpen,
    setIsServiceSelectionOpen,
  ] = useState(false);

  const [services, setServices] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [selectedService, setSelectedService] =
    useState(null);

  const [isServiceLoading, setIsServiceLoading] =
    useState(false);

  const [serviceError, setServiceError] =
    useState(null);


  const [selectedRequest, setSelectedRequest] =
    useState(null);

  const [isDetailsOpen, setIsDetailsOpen] =
    useState(false);

  const [isDetailsLoading, setIsDetailsLoading] =
    useState(false);

  const [detailsError, setDetailsError] =
    useState(null);

    const {
      data,
      isLoading,
      isError,
      error,
      refetch,
    } = useQuery(
      [
        "doc-requests",
        currentPage,
        search,
        status,
        category,
        startDate,
        endDate,
      ],
      () => {
        const searchValue = search.trim();
    
        let searchFilters = {};
    
        if (searchValue) {
          // Search by status
          const matchedStatus = [
            "PENDING",
            "PROCESSING",
            "COMPLETED",
            "REJECTED",
          ].find(
            (item) =>
              item.toLowerCase() ===
              searchValue.toLowerCase()
          );
    
          if (matchedStatus) {
            searchFilters.status = matchedStatus;
          } else {
            // Search by service name/code
            const matchedService = serviceTypes.find(
              (item) => {
                const serviceName =
                  item?.serviceName ||
                  item?.service_type_name ||
                  item?.name ||
                  "";
    
                const serviceCode =
                  item?.serviceCode ||
                  item?.service_code ||
                  item?.code ||
                  "";
    
                return (
                  serviceName.toLowerCase() ===
                    searchValue.toLowerCase() ||
                  serviceCode.toLowerCase() ===
                    searchValue.toLowerCase()
                );
              }
            );
    
            if (matchedService) {
              searchFilters.service_type_id =
                Number(matchedService.id);
            } else {
              // Otherwise search by request number
              searchFilters.service_request_no =
                searchValue;
            }
          }
        }
    
        return getDocumentrequests(
          currentPage,
          PAGE_LIMIT,
          {
            ...searchFilters,
    
            // Dropdown filters
            status:
              status || searchFilters.status,
    
            service_type_id: category
              ? Number(category)
              : searchFilters.service_type_id,
    
            from_date:
              startDate || undefined,
    
            to_date:
              endDate || undefined,
          }
        );
      },
      {
        keepPreviousData: true,
        refetchOnWindowFocus: false,
      }
    );
    useEffect(() => {
      if (isOpen) {
        loadServiceTypes();
      }
    }, [isOpen]);
    const loadServiceTypes = async () => {
      try {
        const response = await getDocRequestsService();
    

    
        let serviceData = [];
    
        if (Array.isArray(response)) {
          serviceData = response;
        } else if (Array.isArray(response?.data)) {
          serviceData = response.data;
        } else if (Array.isArray(response?.data?.data)) {
          serviceData = response.data.data;
        }
    
        setServiceTypes(serviceData);
      } catch (error) {
        console.error("Failed to load service types:", error);
      }
    };
   
  const requestData = useMemo(() => {
    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.data)) {
      return data.data;
    }

    if (Array.isArray(data?.data?.requests)) {
      return data.data.requests;
    }

    if (Array.isArray(data?.requests)) {
      return data.requests;
    }

    return [];
  }, [data]);

  const pagination = data?.meta || {};

  const totalPages = pagination?.totalPages || 1;

  const totalItems = pagination?.totalItems || 0;

  const hasNextPage =
    pagination?.hasNextPage ??
    currentPage < totalPages;

  const hasPreviousPage =
    pagination?.hasPreviousPage ??
    currentPage > 1;


  useEffect(() => {
    setCurrentPage(1);
  }, [
    search,
    status,
    category,
    startDate,
    endDate,
  ]);


  const categories = serviceTypes;



  const statuses = useMemo(() => {
    const defaultStatuses = [
      "PENDING",
      "PROCESSING",
      "COMPLETED",
      "REJECTED",
    ];

    const apiStatuses = requestData
      .map((item) => item?.status)
      .filter(Boolean);

    return [
      ...new Set([
        ...defaultStatuses,
        ...apiStatuses,
      ]),
    ];
  }, [requestData]);


  const getSearchFilters = () => {
    const value = search.trim();
  
    if (!value) {
      return {};
    }
  
    // Search by status
    const matchedStatus = statuses.find(
      (item) =>
        item.toLowerCase() === value.toLowerCase()
    );
  
    if (matchedStatus) {
      return {
        status: matchedStatus,
      };
    }
  
    // Search by service
    const matchedService = serviceTypes.find((item) => {
      const serviceName =
        item?.serviceName ||
        item?.service_type_name ||
        item?.name ||
        "";
  
      const serviceCode =
        item?.serviceCode ||
        item?.service_code ||
        item?.code ||
        "";
  
      return (
        serviceName.toLowerCase() === value.toLowerCase() ||
        serviceCode.toLowerCase() === value.toLowerCase()
      );
    });
  
    if (matchedService) {
      return {
        service_type_id: Number(matchedService.id),
      };
    }
  
    // Otherwise search by request number
    return {
      service_request_no: value,
    };
  };
 

 

  const handleNewRequest = async () => {
    setIsServiceSelectionOpen(true);
    setIsServiceLoading(true);
    setServiceError(null);

    try {
      const response =
        await getDocRequestsService();



      let serviceData = [];

      if (Array.isArray(response)) {
        serviceData = response;
      } else if (
        Array.isArray(response?.data)
      ) {
        serviceData = response.data;
      } else if (
        Array.isArray(response?.data?.data)
      ) {
        serviceData = response.data.data;
      } else if (
        Array.isArray(response?.data?.services)
      ) {
        serviceData =
          response.data.services;
      } else if (
        Array.isArray(response?.services)
      ) {
        serviceData = response.services;
      }

      setServices(serviceData);
    } catch (err) {
      console.error(
        "Service types error:",
        err
      );

      setServiceError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to load service types."
      );
    } finally {
      setIsServiceLoading(false);
    }
  };

 

  const handleServiceSelect = (service) => {
    setSelectedService(service);

    setIsServiceSelectionOpen(false);

    setIsNewRequestOpen(true);
  };


  const handleNewRequestClose = () => {
    setIsNewRequestOpen(false);

    setSelectedService(null);
  };

  const handleRequestSuccess = async () => {
    

    setCurrentPage(1);

    await refetch();
  };

  const handleRequestClick = async (request) => {
    const requestId = request?.id;

    if (!requestId) {
      setDetailsError(
        "Document request ID is missing."
      );

      setIsDetailsOpen(true);

      return;
    }

    setIsDetailsOpen(true);

    setIsDetailsLoading(true);

    setDetailsError(null);

    setSelectedRequest(null);

    try {
      const response =
        await getDocumentrequestsByid(
          requestId
        );


      if (response?.success) {
        setSelectedRequest(response.data);
      } else {
        setDetailsError(
          response?.message ||
            "Unable to fetch request details."
        );
      }
    } catch (err) {
      console.error(
        "Document request details error:",
        err
      );

      setDetailsError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to load request details."
      );
    } finally {
      setIsDetailsLoading(false);
    }
  };


  const handleDetailsClose = () => {
    setIsDetailsOpen(false);

    setSelectedRequest(null);

    setDetailsError(null);
  };


  const handleDetailsRetry = () => {
    if (selectedRequest?.id) {
      handleRequestClick(selectedRequest);
    }
  };


  const handleClearFilters = () => {
    setSearch("");

    setStatus("");

    setCategory("");

    setStartDate("");

    setEndDate("");

    setCurrentPage(1);
  };


  const handlePageChange = (pageNumber) => {
    if (
      pageNumber < 1 ||
      pageNumber > totalPages ||
      pageNumber === currentPage
    ) {
      return;
    }

    setCurrentPage(pageNumber);
  };


  const handlePreviousPage = () => {
    if (hasPreviousPage) {
      setCurrentPage((prev) =>
        Math.max(prev - 1, 1)
      );
    }
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      setCurrentPage((prev) =>
        Math.min(prev + 1, totalPages)
      );
    }
  };



  return (
    <>


      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
      >
        <DrawerOverlay />

        <DrawerContent
          maxW="420px"
          width="100%"
        >


          <DrawerCloseButton mt={2} />

          {/* =================================================
              DRAWER HEADER
          ================================================== */}

          <DrawerHeader
            borderBottom="1px solid #E2E8F0"
            px={6}
            py={5}
          >
            <Flex
              justify="space-between"
              align="center"
            >
              <Heading
                size="md"
                fontSize="28px"
                fontWeight="700"
              >
                Requests
              </Heading>

              <Button
                leftIcon={<AddIcon />}
                bg="#b52b2b"
                borderRadius="12px"
                marginRight="3rem"
                color="white"
                height="48px"
                px={5}
                fontSize="16px"
                _hover={{
                  bg: "#9f2424",
                }}
                onClick={handleNewRequest}
              >
                New Request
              </Button>
            </Flex>
          </DrawerHeader>


          <DrawerBody
            py={5}
            px={6}
            overflowY="auto"
          >

            <InputGroup mb={5}>
              <InputLeftElement
                pointerEvents="none"
              >
                <SearchIcon color="gray.400" />
              </InputLeftElement>

              <Input
                // placeholder="Search service, source, status..."
                placeholder="Search loan number......"
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
                height="58px"
                borderRadius="12px"
                borderColor="#D9E2EC"
                fontSize="16px"
              />
            </InputGroup>

            <VStack
              spacing={3}
              align="stretch"
              mb={5}
            >


              <Select
                placeholder="Status"
                value={status}
                onChange={(e) =>
                  setStatus(e.target.value)
                }
                height="58px"
                borderRadius="12px"
                borderColor="#D9E2EC"
              >
                {statuses.map((item) => (
                  <option
                    key={item}
                    value={item}
                  >
                    {item.replace(/_/g, " ")}
                  </option>
                ))}
              </Select>



              <Select
                placeholder="Service"
                value={category}
                onChange={(e) =>
                  setCategory(e.target.value)
                }
                height="58px"
                borderRadius="12px"
                borderColor="#D9E2EC"
              >
                {categories.map((item) => (
                  <option
                    key={item.id}
                    value={item.id}
                  >
                    {item.serviceName}
                  </option>
                ))}
              </Select>

         

              <Flex
                width="100%"
                gap={3}
              >
                <Input
                  type="date"
                  value={startDate}
                  max={
                    endDate || undefined
                  }
                  onChange={(e) =>
                    setStartDate(
                      e.target.value
                    )
                  }
                  height="58px"
                  flex="1"
                  minWidth="0"
                  borderRadius="12px"
                  borderColor="#D9E2EC"
                />

                <Input
                  type="date"
                  value={endDate}
                  min={
                    startDate || undefined
                  }
                  onChange={(e) =>
                    setEndDate(
                      e.target.value
                    )
                  }
                  height="58px"
                  flex="1"
                  minWidth="0"
                  borderRadius="12px"
                  borderColor="#D9E2EC"
                />
              </Flex>
            </VStack>

            {(search ||
              status ||
              category ||
              startDate ||
              endDate) && (
              <Flex
                justify="flex-end"
                mb={5}
              >
                <Button
                  size="sm"
                  variant="outline"
                  borderRadius="8px"
                  onClick={
                    handleClearFilters
                  }
                >
                  Clear Filters
                </Button>
              </Flex>
            )}

            {isLoading && (
              <Flex
                justify="center"
                align="center"
                py={10}
              >
                <Spinner size="lg" />
              </Flex>
            )}


            {isError && (
              <Flex
                direction="column"
                justify="center"
                align="center"
                py={10}
              >
                <Text
                  color="red.500"
                  textAlign="center"
                  mb={4}
                >
                  {error?.message ||
                    "Failed to load requests."}
                </Text>

                <Button
                  size="sm"
                  onClick={() => refetch()}
                >
                  Retry
                </Button>
              </Flex>
            )}


            {!isLoading && !isError && (
              <>
                <VStack
                  spacing={4}
                  align="stretch"
                >
                  
                  {requestData.length > 0 ? (
                    requestData.map(
                      (request) => (
                        <DocumentRequestCard
                          key={request.id}
                          request={request}
                          onClick={
                            handleRequestClick
                          }
                        />
                      )
                    )
                  ) : (
                    <Heading
                      size="sm"
                      textAlign="center"
                      color="gray.500"
                      py={5}
                    >
                      No Requests Found
                    </Heading>
                  )}
                </VStack>


                {totalPages > 1 && (
                  <Box
                    mt={6}
                    pb={4}
                  >

                    <Text
                      fontSize="13px"
                      color="gray.500"
                      textAlign="center"
                      mb={3}
                    >
                      Showing page {currentPage} of{" "}
                      {totalPages} ({totalItems} requests)
                    </Text>


                    <Flex
                      justify="center"
                      align="center"
                      gap={2}
                      flexWrap="wrap"
                    >

                      <Button
                        size="sm"
                        variant="outline"
                        borderRadius="8px"
                        onClick={
                          handlePreviousPage
                        }
                        isDisabled={
                          !hasPreviousPage
                        }
                      >
                        Previous
                      </Button>


                      {Array.from(
                        {
                          length: totalPages,
                        },
                        (_, index) => {
                          const pageNumber =
                            index + 1;

                          return (
                            <Button
                              key={pageNumber}
                              size="sm"
                              minW="36px"
                              borderRadius="8px"
                              variant={
                                currentPage ===
                                pageNumber
                                  ? "solid"
                                  : "outline"
                              }
                              bg={
                                currentPage ===
                                pageNumber
                                  ? "#b52b2b"
                                  : undefined
                              }
                              color={
                                currentPage ===
                                pageNumber
                                  ? "white"
                                  : undefined
                              }
                              _hover={{
                                bg:
                                  currentPage ===
                                  pageNumber
                                    ? "#9f2424"
                                    : "gray.100",
                              }}
                              onClick={() =>
                                handlePageChange(
                                  pageNumber
                                )
                              }
                            >
                              {pageNumber}
                            </Button>
                          );
                        }
                      )}

                      {/* NEXT */}

                      <Button
                        size="sm"
                        variant="outline"
                        borderRadius="8px"
                        onClick={
                          handleNextPage
                        }
                        isDisabled={
                          !hasNextPage
                        }
                      >
                        Next
                      </Button>
                    </Flex>
                  </Box>
                )}
              </>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>



      <Modal
        isOpen={isServiceSelectionOpen}
        onClose={() =>
          setIsServiceSelectionOpen(false)
        }
        isCentered
        size="lg"
      >
        <ModalOverlay />

        <ModalContent borderRadius="20px">
          <ModalHeader>
            Select Service
          </ModalHeader>

          <ModalCloseButton />

          <ModalBody pb={6}>
      

            {isServiceLoading && (
              <Flex
                justify="center"
                align="center"
                direction="column"
                py={10}
              >
                <Spinner
                  size="lg"
                  color="blue.500"
                />

                <Text
                  mt={4}
                  color="gray.500"
                >
                  Loading services...
                </Text>
              </Flex>
            )}


            {!isServiceLoading &&
              serviceError && (
                <Flex
                  direction="column"
                  align="center"
                  py={8}
                >
                  <Text
                    color="red.500"
                    textAlign="center"
                    mb={4}
                  >
                    {serviceError}
                  </Text>

                  <Button
                    size="sm"
                    onClick={
                      handleNewRequest
                    }
                  >
                    Retry
                  </Button>
                </Flex>
              )}


            {!isServiceLoading &&
              !serviceError &&
              services.length > 0 && (
                <VStack
                  spacing={3}
                  align="stretch"
                >
                  {services.map(
                    (service, index) => {
                      const serviceName =
                        service?.serviceName ||
                        service?.service_type_name ||
                        service?.name ||
                        `Service ${
                          index + 1
                        }`;

                      const serviceCode =
                        service?.serviceCode ||
                        service?.service_code ||
                        service?.code ||
                        "";

                      const description =
                        service?.description ||
                        "";

                      return (
                        <Box
                          key={
                            service?.id ||
                            index
                          }
                          border="1px solid"
                          borderColor="gray.200"
                          borderRadius="14px"
                          marginRight="14px"
                          p={4}
                          cursor="pointer"
                          transition="all 0.2s"
                          _hover={{
                            borderColor:
                              "blue.400",
                            bg: "blue.50",
                          }}
                          onClick={() =>
                            handleServiceSelect(
                              service
                            )
                          }
                        >
                                  <Flex
          justify="space-between"
          align="flex-start"
          gap={4}
        >
          <Box
            flex="1"
            minW="0"
          >
            <Text
              fontSize="16px"
              fontWeight="700"
            >
              {serviceName}
            </Text>

            {description && (
              <Text
                fontSize="13px"
                color="gray.500"
                mt={1}
                pr={2}
              >
                {description}
              </Text>
            )}
          </Box>

          {serviceCode && (
            <Badge
              colorScheme="blue"
              borderRadius="15px"
              px={3}
              flexShrink={0}
              mt={1}
            >
              {serviceCode}
            </Badge>
          )}
        </Flex>
                        </Box>
                      );
                    }
                  )}
                </VStack>
              )}


            {!isServiceLoading &&
              !serviceError &&
              services.length === 0 && (
                <Text
                  textAlign="center"
                  color="gray.500"
                  py={8}
                >
                  No services available.
                </Text>
              )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <NewRequestModal
        isOpen={isNewRequestOpen}
        onClose={handleNewRequestClose}
        service={selectedService}
        onSuccess={handleRequestSuccess}
      />

      <DocumentRequestDetailsModal
        isOpen={isDetailsOpen}
        onClose={handleDetailsClose}
        request={selectedRequest}
        isLoading={isDetailsLoading}
        error={detailsError}
        onRetry={handleDetailsRetry}
      />
    </>
  );
};

export default RequestDrawer;